@if (display) {
  <p-dialog [styleClass]="authenticationService?.user?.fontSize === 'SMALL' ? 'custom-form-small' : (authenticationService?.user?.fontSize === 'MEDIUM' ? 'custom-form-medium' : '')"
    header="{{ title | uppercase }}"
    [(visible)]="display"
    showEffect="fade"
    [modal]="true"
    appendTo="body"
    >
<div [ngClass]="{'custom-form-small': authenticationService?.user?.fontSize === 'SMALL', 'custom-form-medium': authenticationService?.user?.fontSize === 'MEDIUM'}">
    <!-- #region BODY -->
    <div class="container-md">
      <div #errorContainer>
        @if (errorMessages.length !== 0) {
          <div>
            @for (error of errorMessages; track error) {
              <div>
                <div class='alert alert-warning' role='alert'>{{error}}</div>
              </div>
            }
          </div>
        }
      </div>
      <!-- ISSUER & SANCTION DATE -->
      <div class="row justify-content-start mt-3">
        <div class="col-sm-6">
          <label for="fine-issuer" class="form-label custom-label fw-bold small mb-2 me-2" i18n>
						<strong>{{ 'tableManagement.fine.issuer' | translate }} (*)</strong>
					</label>
          <input
            type="text"
            id="fine-issuer"
            class="form-control custom-input"
            [(ngModel)]="entity.issuer"
            [style]="{ width: '100%' }"
            [disabled]="saving || (isNew && !isCreateGranted) || (!isNew && !isUpdateGranted)"
            />
        </div>
        <div class="col-sm-6">
          <label for="fine-sanction-date" class="form-label custom-label fw-bold small mb-2 me-2" i18n>
						<strong>{{ 'tableManagement.fine.sanctionDate' | translate }} (*)</strong>
					</label>
          <p-datepicker
            inputId="fine-sanction-date"
            [(ngModel)]="sanctionDate"
            [showTime]="false"
            [style]="{ width: '100%' }"
            dateFormat="{{ i18n.dateFormat }}"
            showIcon="true"
            appendTo="body"
            [disabled]="saving || (isNew && !isCreateGranted) || (!isNew && !isUpdateGranted)"
          ></p-datepicker>
        </div>
      </div>
      <!-- REASON & POINTS -->
      <div class="row justify-content-start mt-3">
        <div class="col-sm-6">
          <label for="fine-reason" class="form-label custom-label fw-bold small mb-2 me-2" i18n>
								<strong>{{ 'tableManagement.fine.reason' | translate }} (*)</strong>
							</label>
          <p-select
            inputId="fine-reason"
            [options]="reasonList"
            [(ngModel)]="entity.reason"
            placeholder="{{ 'tableManagement.fineReason.fineReason' | translate }}"
            dataKey="id"
            optionLabel="reason"
            [style]="{ width: '100%' }"
            appendTo="body"
            [filter]="true"
            filterBy="reason"
            [disabled]="saving || (isNew && !isCreateGranted) || (!isNew && !isUpdateGranted)"
            >
          </p-select>
        </div>
        <div class="col-sm-6">
          <label for="fine-points" class="form-label custom-label fw-bold small mb-2 me-2" i18n>
						{{ 'tableManagement.fine.points' | translate }}
					</label>
          <input
            type="text"
            id="fine-points"
            class="form-control custom-input"
            [(ngModel)]="entity.dgtPoints"
            [style]="{ width: '100%' }"
            [disabled]="saving || (isNew && !isCreateGranted) || (!isNew && !isUpdateGranted)"
            />
        </div>
      </div>
      <!-- FILE NUMBER & AMOUNT -->
      <div class="row justify-content-start mt-3">
        <div class="col-sm-6">
          <label for="fine-amount" class="form-label custom-label fw-bold small mb-2 me-2" i18n>
						{{ 'tableManagement.fine.amount' | translate }}
					</label>
          <div class="input-wrapper" style="width: 100%;">
            <p-inputNumber [showButtons]="true"
              inputId="fine-amount"
              [(ngModel)]="entity.amount"
              mode="decimal"
              locale="es-ES"
              [minFractionDigits]="0"
              [style]="{ width: '100%' }"
              (onKeyDown)="onKeyDownDecimal($event)"
              [disabled]="saving || (isNew && !isCreateGranted) || (!isNew && !isUpdateGranted)"
            ></p-inputNumber>
            <span class="input-symbol">€</span>
          </div>
        </div>
        <div class="col-sm-6">
          <label for="fine-bonus-amount" class="form-label custom-label fw-bold small mb-2 me-2" i18n>
						{{ 'tableManagement.fine.bonusAmount' | translate }}
					</label>
          <div class="input-wrapper" style="width: 100%;">
            <p-inputNumber [showButtons]="true"
              inputId="fine-bonus-amount"
              [(ngModel)]="entity.bonusAmount"
              mode="decimal"
              locale="es-ES"
              [minFractionDigits]="0"
              [style]="{ width: '100%' }"
              (onKeyDown)="onKeyDownDecimal($event)"
              [disabled]="saving || (isNew && !isCreateGranted) || (!isNew && !isUpdateGranted)"
            ></p-inputNumber>
            <span class="input-symbol">€</span>
          </div>
        </div>
      </div>
      <!-- BONUS AMOUNT & RESPONSIBLE -->
      <div class="row justify-content-start mt-3">
        <div class="col-sm-6">
          <label for="fine-responsible" class="form-label custom-label fw-bold small mb-2 me-2" i18n>
								{{ 'tableManagement.fine.responsible' | translate }}
							</label>
          <p-select
            inputId="fine-responsible"
            [options]="responsibleList"
            [(ngModel)]="entity.responsible"
            placeholder="{{ 'tableManagement.fine.responsible' | translate }}"
            dataKey="id"
            [style]="{ width: '100%' }"
            appendTo="body"
            [filter]="true"
            optionLabel="formatResponsibleLabel"
            (onChange)="onChangeResponsible($event)"
            (onFilter)="onFilterResponsible($event)"
            filterBy="formatResponsibleLabel"
            [disabled]="saving  || (isNew && !isCreateGranted) || (!isNew && !isUpdateGranted)"
            >
            <ng-template let-responsible pTemplate="item">
              <div class="flex align-items-center gap-2">
                <div>{{ responsible.surname1 }} {{ responsible.surname2 }}, {{ responsible.name }}</div>
              </div>
            </ng-template>
          </p-select>
        </div>
        <div class="col-sm-6">
          <label for="fine-file-number" class="form-label custom-label fw-bold small mb-2 me-2" i18n>
						<strong>{{ 'tableManagement.fine.fileNumber' | translate }} (*)</strong>
					</label>
          <input
            type="text"
            id="fine-file-number"
            class="form-control custom-input"
            [(ngModel)]="entity.fileNumber"
            [style]="{ width: '100%' }"
            [disabled]="saving || (isNew && !isCreateGranted) || (!isNew && !isUpdateGranted)"
            />
        </div>
      </div>
      <hr />
      <!-- NOTIFICATION DATE & METHOD -->
      <div class="row justify-content-start mt-3">
        <div class="col-sm-6">
          <label for="fine-notification-date" class="form-label custom-label fw-bold small mb-2 me-2" i18n>
						{{ 'tableManagement.fine.notificationDate' | translate }}
					</label>
          <p-datepicker
            inputId="fine-notification-date"
            [(ngModel)]="notificationDate"
            [showTime]="false"
            [style]="{ width: '100%' }"
            dateFormat="{{ i18n.dateFormat }}"
            showIcon="true"
            appendTo="body"
            [disabled]="saving || (isNew && !isCreateGranted) || (!isNew && !isUpdateGranted)"
          ></p-datepicker>
        </div>
        <div class="col-sm-6">
          <label for="fine-notification-method" class="form-label custom-label fw-bold small mb-2 me-2" i18n>
								{{ 'tableManagement.fine.notificationMethod' | translate }}
							</label>
          <p-select
            inputId="fine-notification-method"
            [options]="communicationMethods"
            [(ngModel)]="entity.notificationMethod"
            placeholder="{{ 'tableManagement.fine.notificationMethod' | translate }}"
            [style]="{ width: '100%' }"
            appendTo="body"
            [disabled]="saving  || (isNew && !isCreateGranted) || (!isNew && !isUpdateGranted)"
            >
          </p-select>
        </div>
      </div>
      <!-- IDENTIFICATION REQUEST DATE -->
      <div class="row justify-content-start mt-3">
        <div class="col-sm-6">
          <label for="fine-identification-request-date" class="form-label custom-label fw-bold small mb-2 me-2" i18n>
						{{ 'tableManagement.fine.identificationRequestDate' | translate }}
					</label>
          <p-datepicker
            inputId="fine-identification-request-date"
            [(ngModel)]="identityRequestDate"
            [showTime]="false"
            [style]="{ width: '100%' }"
            dateFormat="{{ i18n.dateFormat }}"
            showIcon="true"
            appendTo="body"
            [disabled]="saving || (isNew && !isCreateGranted) || (!isNew && !isUpdateGranted)"
          ></p-datepicker>
        </div>
      </div>
      <!-- IDENTIFICATION DATE -->
      <div class="row justify-content-start mt-3">
        <div class="col-sm-6">
          <label for="fine-identification-date" class="form-label custom-label fw-bold small mb-2 me-2" i18n>
						{{ 'tableManagement.fine.identificationDate' | translate }}
					</label>
          <p-datepicker
            inputId="fine-identification-date"
            [(ngModel)]="identityDate"
            [showTime]="false"
            [style]="{ width: '100%' }"
            dateFormat="{{ i18n.dateFormat }}"
            showIcon="true"
            appendTo="body"
            [disabled]="saving || (isNew && !isCreateGranted) || (!isNew && !isUpdateGranted)"
          ></p-datepicker>
        </div>
        <div class="col-sm-6">
          <label for="fine-identification-method" class="form-label custom-label fw-bold small mb-2 me-2" i18n>
								{{ 'tableManagement.fine.identificationMethod' | translate }}
							</label>
          <p-select
            inputId="fine-identification-method"
            [options]="communicationMethods"
            [(ngModel)]="entity.identificationMethod"
            placeholder="{{ 'tableManagement.fine.identificationMethod' | translate }}"
            [style]="{ width: '100%' }"
            appendTo="body"
            [disabled]="saving  || (isNew && !isCreateGranted) || (!isNew && !isUpdateGranted)"
            >
          </p-select>
        </div>
      </div>
      <!-- PAID BY DELEGATION DATE -->
      <div class="row justify-content-start mt-3">
        <div class="col-sm-6">
          <label for="fine-payment-date" class="form-label custom-label fw-bold small mb-2 me-2" i18n>
						{{ 'tableManagement.fine.paidByDelegation' | translate }}
					</label>
          <div class="d-flex align-items-center gap-3">
            <p-datepicker
              inputId="fine-payment-date"
              [(ngModel)]="paymentDate"
              [showTime]="false"
              [style]="{ width: '100%' }"
              dateFormat="{{ i18n.dateFormat }}"
              showIcon="true"
              appendTo="body"
              [disabled]="saving || (isNew && !isCreateGranted) || (!isNew && !isUpdateGranted)"
            ></p-datepicker>
            <input
              class="form-check-input d-flex justify-content-center align-items-center custom-checkbox"
              type="checkbox"
              [(ngModel)]="entity.paidByDelegation"
              [disabled]="saving || (isNew && !isCreateGranted) || (!isNew && !isUpdateGranted)"
              />
          </div>
        </div>
      </div>
      <hr />
      <!-- STATUS -->
      <div class="row justify-content-start mt-3">
        <div class="col-sm-6">
          <label for="fine-status" class="form-label custom-label fw-bold small mb-2 me-2" i18n>
						<strong>{{ 'tableManagement.fineStatus.fineStatus' | translate }} (*)</strong>
					</label>
          <p-select
            inputId="fine-status"
            [options]="statusList"
            [(ngModel)]="entity.finesStatus"
            placeholder="{{ 'tableManagement.fineStatus.fineStatus' | translate }}"
            dataKey="id"
            optionLabel="name"
            [style]="{ width: '100%' }"
            appendTo="body"
            [filter]="true"
            filterBy="name"
            (onChange)="onChangeStatus($event)"
            (onFilter)="onFilterStatus($event)"
            [disabled]="saving  || (isNew && !isCreateGranted) || (!isNew && !isUpdateGranted)"
            >
          </p-select>
        </div>
      </div>
      <!-- OBSERVATIONS -->
      <div class="row justify-content-start mt-3">
        <div class="col-12">
          <label for="fine-observations" class="form-label custom-label fw-bold small mb-2 me-2" i18n>
						{{ 'general.observations' | translate }}
					</label>
          <textarea
            id="fine-observations"
            rows="2"
            pInputTextarea
            [pTooltip]="entity.observations"
            tooltipPosition="top"
            [(ngModel)]="entity.observations"
            class="observations"
            fitContent="true"
            [style]="{ width: '100%' }"
            [disabled]="saving || (isNew && !isCreateGranted) || (!isNew && !isUpdateGranted)"
          ></textarea>
        </div>
      </div>
      <div class="mt-3">
        <p-panel header="{{ 'vehicleAssignments.header' | translate }}" class="w-100">
          <div class="row justify-content-start">
            <div class="col-sm-6">
              <label for="fine-vehicle" class="form-label custom-label fw-bold small mb-2 me-2" i18n>
								<strong>{{ 'tableManagement.cardLists.vehicle' | translate }} (*)</strong>
							</label>
              <p-select
                inputId="fine-vehicle"
                [options]="vehicleList"
                [(ngModel)]="entity.vehicle"
                [placeholder]="vehiclePlaceholder"
                dataKey="id"
                optionLabel="name"
                [style]="{ width: '100%' }"
                [disabled]="!editVehicle || saving  || (isNew && !isCreateGranted) || (!isNew && !isUpdateGranted)"
                appendTo="body"
                [filter]="true"
                filterBy="name"
                (onChange)="onChangeVehicle($event)"
                (onFilter)="onFilterVehicle($event)"
                >
              </p-select>
            </div>
            <div class="col-sm-6">
              <label for="fine-driver" class="form-label custom-label fw-bold small mb-2 me-2" i18n>
								<strong>{{ 'tableManagement.fine.driver' | translate }} (*)</strong>
							</label>
              <p-select
                inputId="fine-driver"
                [options]="driverList"
                [(ngModel)]="entity.driver"
                placeholder="{{ 'general.select' | translate }} {{ 'tableManagement.fine.driver' | translate }}"
                dataKey="id"
                optionLabel="formatDriverLabel"
                [style]="{ width: '100%' }"
                appendTo="body"
                [filter]="true"
                (onChange)="onChangeDriver($event)"
                (onFilter)="onFilterDriver($event)"
                [disabled]="saving  || (isNew && !isCreateGranted) || (!isNew && !isUpdateGranted)"
                >
                <ng-template let-driver pTemplate="item">
                  <div class="flex align-items-center gap-2">
                    <div>
                      ({{ driver.employee.code }}) {{ driver.employee.user.surname1 }} {{ driver.employee.user.surname2 }}
                      {{ driver.employee.user.name }}
                    </div>
                  </div>
                </ng-template>
              </p-select>
            </div>
          </div>
        </p-panel>
      </div>
      <!-- taula de documents -->
      @if (!isNew) {
        <div class="row mt-3">
          <app-doc-table type="fines" [entity]="entity" [nested]="true" [ids]="ids" (return)="refresh()">
          </app-doc-table>
        </div>
      }
      <!-- ACTIVE -->
      <div class="row justify-content-start mt-3">
        <div class="col-sm-6">
          <label for="fine-active" class="form-label custom-label fw-bold small mb-2 me-2" i18n>
						{{ 'control-panel.poi-categories.poiEnabled' | translate }}
					</label>
          <input
            id="fine-active"
            class="form-check-input d-flex justify-content-center align-items-center custom-checkbox"
            type="checkbox"
            [(ngModel)]="active"
            [disabled]="saving || (isNew && !isCreateGranted) || (!isNew && !isUpdateGranted)"
            />
        </div>
      </div>
    </div>
    <!-- #endregion BODY -->
  </div>
<!-- #region FOOTER -->
<ng-template pTemplate="footer">
      <div class="d-flex justify-content-center bd-highlight">
        <div class="p-2 bd-highlight">
          @if (isNew && isCreateGranted) {
            <div>
              <button class="btn custom-button" (click)="saveChanges()" i18n [disabled]="saving">
						{{ saving ? ('general.saving' | translate) : ('general.create' | translate) }}
					</button>
            </div>
          }
          @if (!isNew && isUpdateGranted) {
            <div>
              <button class="btn custom-button" (click)="saveChanges()" i18n [disabled]="saving">
						{{ saving ? ('general.saving' | translate) : ('general.save' | translate) }}
					</button>
            </div>
          }
        </div>
        <div class="p-2 bd-highlight">
          @if (!isNew && isDisableGranted) {
            <div>
              <button class="btn custom-button" (click)="changeStatus(!active)" i18n [disabled]="saving">
						{{ 'general.changeStatus' | translate }}
					</button>
            </div>
          }
        </div>
      </div>
    </ng-template>
<!-- #endregion FOOTER -->
</p-dialog>
}
